import type { AxiosRequestConfig } from 'axios';
import { api } from '../../axios.instance';

export type ExportUsageReportRequestDto = {
  from: string;
  to: string;
};

export const exportUsageReport = (
  params: ExportUsageReportRequestDto,
  config?: AxiosRequestConfig<ExportUsageReportRequestDto>
) => {
  return api.get('/tracking/usage-report/export', {
    params,
    responseType: 'blob',
    ...config,
  });
};
